/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import {
  Box,
  ChevronDownIcon,
  Flex,
  Label,
  Menu,
  MenuButton,
  MenuLink,
  MenuList,
  Text,
} from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import { jsx } from 'theme-ui';

export default function MultisiteSwitcher({ ...rest }) {
  const sites = JSON.parse(process.env.GATSBY_MULTISITES || '');
  const activeSite = sites.find((site) => site.isActive);
  return (
    <Menu>
      <MenuButton variant="text" {...rest}>
        <Flex align="center">
          <Box sx={{ textAlign: 'left' }}>
            <Label
              variant="small"
              sx={{ color: 'brand.smoke', lineHeight: '12px' }}
            >
              <Trans>Event</Trans>
            </Label>
            <Text variant="small" sx={{ lineHeight: '16px' }}>
              {activeSite.name}
            </Text>
          </Box>
          <ChevronDownIcon
            sx={{ marginLeft: 1, color: 'brand.smoke' }}
            size="small"
          />
        </Flex>
      </MenuButton>
      <MenuList>
        {sites.map((site) => (
          <MenuLink key={site.name} href={site.url}>
            {site.name}
          </MenuLink>
        ))}
      </MenuList>
    </Menu>
  );
}
